import { render, staticRenderFns } from "./MeuPerfil.vue?vue&type=template&id=32a5d2c7&scoped=true&"
import script from "./MeuPerfil.vue?vue&type=script&lang=js&"
export * from "./MeuPerfil.vue?vue&type=script&lang=js&"
import style0 from "./MeuPerfil.vue?vue&type=style&index=0&id=32a5d2c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a5d2c7",
  null
  
)

export default component.exports